/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContractualizationData } from './ContractualizationData';
import {
    ContractualizationDataFromJSON,
    ContractualizationDataFromJSONTyped,
    ContractualizationDataToJSON,
    ContractualizationDataToJSONTyped,
} from './ContractualizationData';
import type { RiskData } from './RiskData';
import {
    RiskDataFromJSON,
    RiskDataFromJSONTyped,
    RiskDataToJSON,
    RiskDataToJSONTyped,
} from './RiskData';
import type { SubscriptionProcessStateDto } from './SubscriptionProcessStateDto';
import {
    SubscriptionProcessStateDtoFromJSON,
    SubscriptionProcessStateDtoFromJSONTyped,
    SubscriptionProcessStateDtoToJSON,
    SubscriptionProcessStateDtoToJSONTyped,
} from './SubscriptionProcessStateDto';
import type { BranchCode } from './BranchCode';
import {
    BranchCodeFromJSON,
    BranchCodeFromJSONTyped,
    BranchCodeToJSON,
    BranchCodeToJSONTyped,
} from './BranchCode';

/**
 * Complete subscription process response with state and data
 * @export
 * @interface SubscriptionProcessResponse
 */
export interface SubscriptionProcessResponse {
    /**
     * 
     * @type {BranchCode}
     * @memberof SubscriptionProcessResponse
     */
    branchCode: BranchCode;
    /**
     * Unique identifier of the risk/project
     * @type {string}
     * @memberof SubscriptionProcessResponse
     */
    riskId: string;
    /**
     * Human-readable folder identifier (e.g., UPI-2024-005678)
     * @type {string}
     * @memberof SubscriptionProcessResponse
     */
    folderIdentifier: string;
    /**
     * 
     * @type {SubscriptionProcessStateDto}
     * @memberof SubscriptionProcessResponse
     */
    subscriptionState: SubscriptionProcessStateDto;
    /**
     * 
     * @type {RiskData}
     * @memberof SubscriptionProcessResponse
     */
    riskData?: RiskData;
    /**
     * 
     * @type {ContractualizationData}
     * @memberof SubscriptionProcessResponse
     */
    contractualizationData?: ContractualizationData | null;
    /**
     * Number of unread history events in the activity feed for this risk
     * @type {number}
     * @memberof SubscriptionProcessResponse
     */
    unreadHistoryCount?: number;
}



/**
 * Check if a given object implements the SubscriptionProcessResponse interface.
 */
export function instanceOfSubscriptionProcessResponse(value: object): value is SubscriptionProcessResponse {
    if (!('branchCode' in value) || value['branchCode'] === undefined) return false;
    if (!('riskId' in value) || value['riskId'] === undefined) return false;
    if (!('folderIdentifier' in value) || value['folderIdentifier'] === undefined) return false;
    if (!('subscriptionState' in value) || value['subscriptionState'] === undefined) return false;
    return true;
}

export function SubscriptionProcessResponseFromJSON(json: any): SubscriptionProcessResponse {
    return SubscriptionProcessResponseFromJSONTyped(json, false);
}

export function SubscriptionProcessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionProcessResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'branchCode': BranchCodeFromJSON(json['branchCode']),
        'riskId': json['riskId'],
        'folderIdentifier': json['folderIdentifier'],
        'subscriptionState': SubscriptionProcessStateDtoFromJSON(json['subscriptionState']),
        'riskData': json['riskData'] == null ? undefined : RiskDataFromJSON(json['riskData']),
        'contractualizationData': json['contractualizationData'] == null ? undefined : ContractualizationDataFromJSON(json['contractualizationData']),
        'unreadHistoryCount': json['unreadHistoryCount'] == null ? undefined : json['unreadHistoryCount'],
    };
}

export function SubscriptionProcessResponseToJSON(json: any): SubscriptionProcessResponse {
    return SubscriptionProcessResponseToJSONTyped(json, false);
}

export function SubscriptionProcessResponseToJSONTyped(value?: SubscriptionProcessResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'branchCode': BranchCodeToJSON(value['branchCode']),
        'riskId': value['riskId'],
        'folderIdentifier': value['folderIdentifier'],
        'subscriptionState': SubscriptionProcessStateDtoToJSON(value['subscriptionState']),
        'riskData': RiskDataToJSON(value['riskData']),
        'contractualizationData': ContractualizationDataToJSON(value['contractualizationData']),
        'unreadHistoryCount': value['unreadHistoryCount'],
    };
}

